import { Component, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import OurWork from "@/pages/OurWork";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Admin from "@/pages/admin/Admin";
import ChatWidget from "@/components/ChatWidget";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-ivory px-6 text-center">
          <p className="font-serif text-3xl text-charcoal">Something has gone astray.</p>
          <p className="text-sm text-charcoal/60">Please refresh the page, or call Lucas on 0456 492 849.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

function LenisRoot({ children }) {
  useEffect(() => {
    let lenis;
    let raf;
    (async () => {
      const Lenis = (await import("lenis")).default;
      lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
      window.__lenis = lenis;
      const loop = (t) => {
        lenis.raf(t);
        raf = requestAnimationFrame(loop);
      };
      raf = requestAnimationFrame(loop);
    })();
    return () => {
      cancelAnimationFrame(raf);
      if (lenis) lenis.destroy();
      window.__lenis = null;
    };
  }, []);
  return children;
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function Shell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <LenisRoot>
      <ScrollToTop />
      {!isAdmin && <Nav />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/our-work" element={<OurWork />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={<Home />} />
      </Routes>
      {!isAdmin && <ChatWidget />}
      {!isAdmin && <Footer />}
    </LenisRoot>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <div className="grain bg-ivory font-sans text-charcoal">
        <BrowserRouter>
          <Shell />
        </BrowserRouter>
        <Toaster position="bottom-right" richColors toastOptions={{ style: { fontFamily: "'Plus Jakarta Sans', sans-serif" } }} />
      </div>
    </ErrorBoundary>
  );
}
